/**
 * DevExtreme (ui/html_editor/formats/size.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _quill_importer = require("../quill_importer");
var quill = (0, _quill_importer.getQuill)();
var SizeStyle = quill.import("attributors/style/size");
SizeStyle.whitelist = null;
exports.default = SizeStyle;



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/html_editor/formats/size.js
// module id = ../../../../devextreme/ui/html_editor/formats/size.js
// module chunks = common